import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useClientAuth } from "../../contexts/ClientAuthContext";
import "./client.css";

export default function ClientLogin() {
    const { isSupabaseReady, isLoading, user, signIn, lastError } = useClientAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (user) {
            const redirectTo = location.state?.from?.pathname ?? "/client/dashboard";
            navigate(redirectTo, { replace: true });
        }
    }, [user, navigate, location.state]);

    useEffect(() => {
        if (lastError) {
            setError(lastError.message ?? "Giriş işlemi gerçekleştirilemedi.");
        }
    }, [lastError]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError("");

        if (!isSupabaseReady) {
            setError("Supabase yapılandırması eksik olduğu için giriş yapılamıyor.");
            return;
        }

        try {
            setSubmitting(true);
            await signIn({ email, password });
        } catch (authError) {
            setError(authError.message ?? "Giriş yapılamadı. Lütfen bilgilerinizi kontrol edin.");
            setSubmitting(false);
        }
    };

    if (!isSupabaseReady) {
        return (
            <div className="client-shell">
                <div className="client-card">
                    <div className="client-card__header">
                        <span className="client-card__badge">Modelerman</span>
                        <h1 className="client-card__title">Müşteri paneli yapılandırılmadı</h1>
                        <p className="client-card__subtitle">
                            Supabase ortam değişkenleri tanımlanmadığı için giriş ekranı aktif değil. Lütfen .env dosyanıza
                            REACT_APP_SUPABASE_URL ve REACT_APP_SUPABASE_ANON_KEY değerlerini ekledikten sonra sunucuyu yeniden
                            başlatın.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="client-shell">
            <div className="client-card">
                <div className="client-card__header">
                    <span className="client-card__badge">Modelerman</span>
                    <h1 className="client-card__title">Müşteri paneline giriş</h1>
                    <p className="client-card__subtitle">
                        Proje dosyalarınıza ve revizyon notlarına erişmek için kayıtlı e-posta adresinizle giriş yapın.
                    </p>
                </div>

                <form className="client-form" onSubmit={handleSubmit}>
                    <label htmlFor="client-email">
                        E-posta
                        <input
                            id="client-email"
                            type="email"
                            autoComplete="email"
                            value={email}
                            onChange={(event) => setEmail(event.target.value)}
                            placeholder="mail@ornek.com"
                            required
                        />
                    </label>

                    <label htmlFor="client-password">
                        Şifre
                        <input
                            id="client-password"
                            type="password"
                            autoComplete="current-password"
                            value={password}
                            onChange={(event) => setPassword(event.target.value)}
                            placeholder="••••••••"
                            required
                        />
                    </label>

                    {error && <p className="client-form__error">{error}</p>}

                    <button className="client-form__submit" type="submit" disabled={submitting || isLoading}>
                        {submitting ? "Giriş yapılıyor..." : "Giriş yap"}
                    </button>
                </form>

                <p className="client-form__hint">
                    Henüz hesabınız yok mu? <Link className="client-form__link" to="/client/register">Hesap oluştur</Link>
                </p>
            </div>
        </div>
    );
}
